import { useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import useFirstViewportEntry from "../hooks/useFirstViewportEntry";
import { viewportData } from "../data/constants";
import { CustomLeftArrow, CustomRightArrow } from "./CustomButtons";
import { ProductCard } from "./ProductCard";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";
import { getLang } from "../redux/selectors";

export const MenuSection = ({ data, page = "main" }) => {
  const ref = useRef(null);
  const isVisible = useFirstViewportEntry(ref);
  const lang = useSelector(getLang);
  const availableProducts = data.products.filter((el) => el.show);
  const [selected, setSelected] = useState(0);

  const handleBeforeChange = (nextSlide, { currentSlide }) => {
    if (nextSlide > currentSlide) {
      setSelected((prev) => ++prev);
    } else {
      setSelected((prev) => --prev);
    }
  };

  if (availableProducts.length === 0) {
    return null;
  }

  return (
    <div
      id={`menu_${data.categoryId}`}
      className={`menu-section ${isVisible > 0 ? "visible" : ""} `}
      ref={ref}
    >
      <h3 className="section-header">{data.categoryName[lang]}</h3>

      <Carousel
        responsive={viewportData}
        beforeChange={handleBeforeChange}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        showThumbs={false}
      >
        {availableProducts
          .sort((a, b) => a.order - b.order)
          .map((el) => (
            <ProductCard key={el.productId} product={el} page={page} />
          ))}
      </Carousel>

      <div className="flex justify-center sm:hidden">
        {availableProducts
          .sort((a, b) => a.order - b.order)
          .map((el, idx) => (
            <div
              key={el.productId}
              className={`w-3 h-3 rounded-full border-2 mt-1 mx-[1px] border-gray-400 ${
                selected === idx ? "bg-mainRed" : ""
              }`}
            />
          ))}
      </div>
    </div>
  );
};
